import { render, staticRenderFns } from "./PaginaAllegatoC.vue?vue&type=template&id=6f4573e0"
import script from "./PaginaAllegatoC.vue?vue&type=script&lang=js"
export * from "./PaginaAllegatoC.vue?vue&type=script&lang=js"
import style0 from "./PaginaAllegatoC.vue?vue&type=style&index=0&id=6f4573e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports